"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("../../..");
const trimmer = (str, trim = true, asString = true) => {
    if (asString) {
        str = str || '';
    }
    if (trim && typeof str === 'string') {
        return str.trim();
    }
    return str;
};
exports.getEmailTemplateBlockDataForKey = (block, key, trim = false, asString = true) => {
    return trimmer(block.contentItem &&
        block.contentItem[key] &&
        block.contentItem[key].data &&
        block.contentItem[key].data, trim, asString);
};
exports.getEmailTemplateBlockData = (block, type, trim = false, asString = true) => {
    switch (type) {
        case 'displayName':
            return trimmer(__1.getBlockDisplayName(block));
        case 'linkToPost':
            return (exports.getEmailTemplateBlockDataForKey(block, 'link', true, true) ||
                exports.getEmailTemplateBlockDataForKey(block, 'url', true, true));
        case 'userContent':
            return trimmer(block.contentStr, trim, asString);
        case 'importedContent':
            return trimmer(block.contentStr || // TODO: Only set contentStr when there is a successful conversion. Maybe `convertedContentStr` ?
                (block.contentItem &&
                    block.contentFieldKey &&
                    exports.getEmailTemplateBlockDataForKey(block, block.contentFieldKey, trim, asString)), trim, asString);
        default:
            throw new Error(`Type is not valid: ${type}`);
    }
};
//# sourceMappingURL=getEmailTemplateBlockData.js.map